import React, { useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import slide1 from '../../assets/SchoolBuilding.jpg';
import slide2 from '../../assets/SchoolEvent.jpg';
import slide3 from '../../assets/SchoolEventAudi.jpg';
import slide4 from '../../assets/SchoolEventOthr.jpg';
import '../../stylings/CarouselSection.css';

const slides = [
  {
    img: slide1,
    title: 'Welcome to Akash Model Sr. Sec. School',
    subtitle: 'Nurturing Minds, Building Futures – Since 1991',
    btn: 'Explore More',
    link: '/about-school',
  },
  {
    img: slide2,
    title: 'Excellence in Education',
    subtitle: 'CBSE Affiliated | Co-Educational | Modern Infrastructure',
    btn: 'Our Achievements',
    link: '/about-school',
  },
  {
    img: slide3,
    title: 'Cultural & Co-curricular Activities',
    subtitle: 'Holistic Development Beyond the Classroom',
    btn: 'View Gallery',
    link: '/galleryall',
  },
  {
    img: slide4,
    title: 'Admissions Open 2025–26',
    subtitle: "Enroll Your Child in Delhi's Premier School",
    btn: 'Contact Us',
    link: '/contact',
  },
];

function restartZoom(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  if (!activeSlide) return;
  const img = activeSlide.querySelector('.carousel-slide-img');
  if (!img) return;
  img.style.animation = 'none';
  // Force reflow so the browser registers the reset before re-applying
  void img.offsetWidth;
  img.style.animation = '';
}

export default function CarouselSection() {
  const handleSlideChange = useCallback((swiper) => restartZoom(swiper), []);

  return (
    <div className="carousel-section">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        navigation
        loop
        className="hero-swiper"
        onSlideChange={handleSlideChange}
        onSwiper={(swiper) => restartZoom(swiper)}
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            <div className="carousel-slide">
              <img
                src={slide.img}
                alt={slide.title}
                className="carousel-slide-img"
              />
              <div className="carousel-overlay">
                <div className="carousel-caption">
                  <h2 className="carousel-title">{slide.title}</h2>
                  <p className="carousel-subtitle">{slide.subtitle}</p>
                  <a href={slide.link} className="carousel-btn">{slide.btn}</a>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
